import { CeilingHeightContainer } from '../../containers/advancedFilters/CeilingHeightContainer';
import { IFilter } from '../../types/filters';

export const ceilingHeight: IFilter = {
  component: CeilingHeightContainer,
};
